import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../Style/Quiz.css';

const quizData = [
  {
    question: "Quel ingrédient donne la texture légère aux génoises ?",
    options: ["Sucre", "Farine", "Œufs", "Beurre"],
    answer: "Œufs",
    explanation: "Les œufs permettent d'aérer la pâte et de donner une texture légère.",
    imageUrl: "https://cdn.pixabay.com/photo/2015/05/07/15/08/cookie-756601_1280.jpg"
  },
  {
    question: "Dans quel type de pâte utilise-t-on du beurre, de la farine et de l'eau pour obtenir une pâte ferme et friable ?",
    options: ["Pâte brisée", "Pâte sablée", "Pâte feuilletée", "Pâte à choux"],
    answer: "Pâte brisée",
    explanation: "La pâte brisée est utilisée pour des tartes ou des quiches, elle est ferme et friable.",
    imageUrl: "https://cdn.pixabay.com/photo/2016/03/27/22/38/cake-1284548_1280.jpg"
  },
  {
    question: "Dans une recette de gâteau au chocolat, pourquoi doit-on tamiser la farine ?",
    options: ["Pour éviter les grumeaux", "Pour rendre le gâteau plus léger", "Pour ajouter du goût", "Pour ajouter de l'humidité"],
    answer: "Pour éviter les grumeaux",
    explanation: "Le tamisage permet d'éviter les grumeaux et d'obtenir une pâte homogène.",
    imageUrl: "https://cdn.pixabay.com/photo/2016/01/11/07/18/cupcakes-1133146_1280.jpg"
  },
  {
    question: "Quel ingrédient est principalement utilisé dans une recette de pâte à choux pour lier la pâte ?",
    options: ["Sucre", "Œufs", "Lait", "Beurre"],
    answer: "Œufs",
    explanation: "Les œufs sont essentiels pour la pâte à choux afin de lier la pâte et lui donner de la consistance.",
    imageUrl: "https://cdn.pixabay.com/photo/2019/09/02/06/22/chocolate-cake-4446608_1280.jpg"
  },
  {
    question: "Dans une recette de pâte feuilletée, quel est l’ingrédient clé pour obtenir des couches superposées ?",
    options: ["Beurre", "Sucre", "Farine", "Œufs"],
    answer: "Beurre",
    explanation: "Le beurre est l'ingrédient clé qui permet d'obtenir les couches fines et superposées de la pâte feuilletée.",
    imageUrl: "https://cdn.pixabay.com/photo/2021/02/13/13/50/tart-6011609_1280.jpg"
  },
  {
    question: "Quel ingrédient est souvent utilisé dans la préparation d'un fondant au chocolat pour apporter de la douceur ?",
    options: ["Beurre", "Sucre glace", "Sucre en poudre", "Miel"],
    answer: "Sucre glace",
    explanation: "Le sucre glace est souvent utilisé pour donner une texture lisse et douce au fondant au chocolat.",
    imageUrl: "https://cdn.pixabay.com/photo/2016/11/29/09/00/doughnuts-1868573_1280.jpg"
  },
  {
    question: "Pourquoi les blancs d'œufs sont-ils battus en neige dans une mousse au chocolat ?",
    options: ["Pour ajouter de la douceur", "Pour aérer la mousse", "Pour durcir la mousse", "Pour donner de la couleur"],
    answer: "Pour aérer la mousse",
    explanation: "Les blancs d'œufs battus en neige permettent de donner une texture légère et aérée à la mousse au chocolat.",
    imageUrl: "https://cdn.pixabay.com/photo/2023/04/11/16/04/berries-7917661_1280.jpg"
  },
  {
    question: "Quel type de chocolat est généralement utilisé dans une mousse au chocolat ?",
    options: ["Chocolat au lait", "Chocolat blanc", "Chocolat noir", "Chocolat au caramel"],
    answer: "Chocolat noir",
    explanation: "Le chocolat noir est généralement utilisé pour une mousse au chocolat riche et intense.",
    imageUrl: "https://cdn.pixabay.com/photo/2013/08/07/11/36/cream-170439_1280.jpg"
  },
  {
    question: "Quelle est la principale différence entre la pâte sablée et la pâte brisée ?",
    options: ["La pâte sablée est plus sucrée", "La pâte brisée est plus friable", "La pâte sablée est plus souple", "La pâte brisée est plus légère"],
    answer: "La pâte sablée est plus sucrée",
    explanation: "La pâte sablée est plus sucrée et est utilisée dans des desserts comme les tartes ou biscuits.",
    imageUrl: "https://cdn.pixabay.com/photo/2015/11/01/23/20/pastry-1017706_1280.jpg"
  },
  {
    question: "Quel ingrédient est utilisé pour épaissir la crème pâtissière ?",
    options: ["Farine", "Maïzena", "Jaunes d'œufs", "Lait"],
    answer: "Jaunes d'œufs",
    explanation: "Les jaunes d'œufs épaississent la crème pâtissière et lui donnent une texture lisse.",
    imageUrl: "https://cdn.pixabay.com/photo/2013/08/07/11/18/bake-170437_1280.jpg"
  },
  {
    question: "Pourquoi laisse-t-on reposer une pâte à crêpes avant cuisson ?",
    options: ["Pour ajouter du goût", "Pour éviter les grumeaux", "Pour rendre la pâte plus souple", "Pour lever la pâte"],
    answer: "Pour rendre la pâte plus souple",
    explanation: "Le repos permet à la farine d'absorber le liquide et rend la pâte plus homogène et souple.",
    imageUrl: "https://cdn.pixabay.com/photo/2023/06/22/22/29/cookies-8082386_1280.jpg"
  },
  {
    question: "Quel est l’ingrédient clé pour réussir une meringue ?",
    options: ["Farine", "Œufs", "Sucre", "Beurre"],
    answer: "Œufs",
    explanation: "Les blancs d'œufs battus avec du sucre sont la base de la meringue.",
    imageUrl: "https://cdn.pixabay.com/photo/2020/11/03/23/55/cookies-5711139_1280.jpg"
  },
  {
    question: "Dans une tarte tatin, quel fruit est traditionnellement utilisé ?",
    options: ["Pommes", "Poires", "Cerises", "Pêches"],
    answer: "Pommes",
    explanation: "La tarte tatin est typiquement préparée avec des pommes caramélisées.",
    imageUrl: "https://cdn.pixabay.com/photo/2021/11/09/07/21/pastry-6780834_1280.jpg"
  },
  {
    question: "Quel est le rôle du beurre dans une pâte sablée ?",
    options: ["Lier la pâte", "Donner du goût", "Apporter de la texture", "Faire lever la pâte"],
    answer: "Apporter de la texture",
    explanation: "Le beurre rend la pâte sablée friable et fondante.",
    imageUrl: "https://cdn.pixabay.com/photo/2016/03/27/19/23/tart-1283822_1280.jpg"
  },
  {
    question: "Quelle pâte utilise-t-on pour réaliser des éclairs ?",
    options: ["Pâte sablée", "Pâte à choux", "Pâte brisée", "Pâte feuilletée"],
    answer: "Pâte à choux",
    explanation: "La pâte à choux permet aux éclairs de gonfler et de rester légers.",
    imageUrl: "https://cdn.pixabay.com/photo/2015/01/14/19/20/bake-599521_1280.jpg"
  },
  {
    question: "Pourquoi tamiser la farine avant de l’ajouter à une pâte ?",
    options: ["Pour enrichir le goût", "Pour éviter les grumeaux", "Pour activer la levure", "Pour améliorer la texture"],
    answer: "Pour éviter les grumeaux",
    explanation: "Tamiser la farine permet d'éviter les grumeaux et d'obtenir un mélange homogène.",
    imageUrl: "https://cdn.pixabay.com/photo/2023/09/25/07/54/lemon-cake-8274419_1280.jpg"
  }
];

const Quiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [answers, setAnswers] = useState([]);

  const handleAnswerOptionClick = (selectedOption) => {
    const isCorrect = selectedOption === quizData[currentQuestion].answer;
    if (isCorrect) setScore(score + 1);

    setAnswers((prevAnswers) => [
      ...prevAnswers,
      {
        question: quizData[currentQuestion].question,
        selected: selectedOption,
        correct: quizData[currentQuestion].answer,
        explanation: quizData[currentQuestion].explanation,
      },
    ]);

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < quizData.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowScore(true);
    }
  };

  const restartQuiz = () => {
    setCurrentQuestion(0);
    setScore(0);
    setShowScore(false);
    setAnswers([]);
  };

  return (
    <div className="quiz-container">
      {showScore ? (
        <ScoreSection
          score={score}
          totalQuestions={quizData.length}
          onRestart={restartQuiz}
          answers={answers}
        />
      ) : (
        <QuestionSection
          questionData={quizData[currentQuestion]}
          currentQuestionIndex={currentQuestion}
          totalQuestions={quizData.length}
          onAnswerClick={handleAnswerOptionClick}
        />
      )}
    </div>
  );
};
const ScoreSection = ({ score, totalQuestions, onRestart, answers }) => (
  <motion.div
    className="score-section"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1 }}
  >
    <h2 className="score-title">Votre score : {score} sur {totalQuestions}</h2>
    <h3 className="explanation-title">Résultats :</h3>
    <ul className="answer-list">
      {answers.map((answer, index) => (
        <li key={index} className="answer-item">
          <p><strong>Question :</strong> {answer.question}</p>
          <p><strong>Votre réponse :</strong> {answer.selected}</p>
          <p><strong>Bonne réponse :</strong> {answer.correct}</p>
          <p><strong>Explication :</strong> {answer.explanation}</p>
          <hr />
        </li>
      ))}
    </ul>
    <button className="restart-button" onClick={onRestart}>Recommencer le quiz</button>
  </motion.div>
);

const QuestionSection = ({ questionData, currentQuestionIndex, totalQuestions, onAnswerClick }) => {
  if (!questionData) return <p>Chargement des questions...</p>;

  return (
    <motion.div
      className="question-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <h2>{`Question ${currentQuestionIndex + 1} / ${totalQuestions}`}</h2>
      <p>{questionData.question}</p>
      <div className="options-section">
        {questionData.options.map((option, index) => (
          <motion.button
            key={index}
            onClick={() => onAnswerClick(option)}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.2 }}
          >
            {option}
          </motion.button>
        ))}
      </div>

      {/* Affichage de l'image sous la question */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="image-container"
      >
        {questionData.imageUrl ? (
          <img
            src={questionData.imageUrl}
            alt={questionData.question}
            className="quiz-image"
          />
        ) : (
          <p>Aucune image disponible pour cette question.</p>
        )}
      </motion.div>
    </motion.div>
  );
};

export default Quiz;
